var render = function render(){var _vm=this,_c=_vm._self._c;return _c('category-layout',{on:{"changeLanguage":_vm.getItems}},[_c('categories',{attrs:{"categories":_vm.categories}}),_c('pagination400',{staticClass:"mt-3",attrs:{"on-change-page":_vm.changePage,"meta":_vm.pagination}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }